// extracted by mini-css-extract-plugin
module.exports = {"InputEmailSuggestionButton":"InputEmail_InputEmailSuggestionButton__Am9OO"};